/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_SubtitleInputs */

const en_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your credentials to continue`)
};

const de_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib deine Anmeldedaten ein, um fortzufahren`)
};

const fr_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre tes identifiants pour continuer`)
};

const es_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese sus credenciales para continuar`)
};

const it_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci le tue credenziali per continuare`)
};

const nl_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer je inloggegevens in om door te gaan`)
};

const pl_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podaj swoje dane logowania, aby kontynuować`)
};

const fi_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syötä tunnuksesi jatkaaksesi`)
};

const da_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast dine oplysninger for at fortsætte`)
};

const sv_auth_login_subtitle = /** @type {(inputs: Auth_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange dina uppgifter för att fortsätta`)
};

/**
* | output |
* | --- |
* | "Enter your credentials to continue" |
*
* @param {Auth_Login_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_login_subtitle = /** @type {((inputs?: Auth_Login_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_login_subtitle(inputs)
	if (locale === "fr") return fr_auth_login_subtitle(inputs)
	if (locale === "es") return es_auth_login_subtitle(inputs)
	if (locale === "it") return it_auth_login_subtitle(inputs)
	if (locale === "nl") return nl_auth_login_subtitle(inputs)
	if (locale === "pl") return pl_auth_login_subtitle(inputs)
	if (locale === "fi") return fi_auth_login_subtitle(inputs)
	if (locale === "da") return da_auth_login_subtitle(inputs)
	if (locale === "sv") return sv_auth_login_subtitle(inputs)
	return en_auth_login_subtitle(inputs)
});